export const styles = {
  slide: {
    margin: "0 auto"
  },
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignitems: "center",
    height: "90%",
    width: "95%",
    margin: "0 auto"
  },
  indicatorContainer: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center"
  }
}



// WEBPACK FOOTER //
// ./src/styles/slideshow-styles.js